/**
 * Steps JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Steps
 */
class Steps {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.steps = $( '#js-steps-wrap' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Set the steps wrap minus margin while resizing
        $( window ).on( 'resize', ( e ) => {
            this.liftSteps();
        });

    }

    /**
     * Set the margin top half of the wraps own height to keep the flow
     * of other elements normal
     */
    liftSteps() {

        // Set the minus margin if the window is wide enough
        if ( $( window ).width() >= 1024 ) {

            // Get the height and split it to transform the steps-wrap 50% up.
            let stepsHeight = $( this.steps ).height();
            stepsHeight = stepsHeight / 2;

            // Lift the steps up
            this.steps.css( 'margin-top', -stepsHeight );
        } else {

            // We don't need margin top on smaller sizes
            this.steps.css( 'margin-top', 0 );
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.liftSteps();
    }
}

// Export the class reference.
module.exports = Steps;



// WEBPACK FOOTER //
// ./assets/scripts/steps.js